module.exports = __webpack_public_path__ + "img/fushimi-HP-pattern003sp.b0643af8.png";